var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStructureHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 120 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "background",
    style: {
      fill: "#0f0",
      stroke: "#0f0",
      strokeWidth: 20
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "foreground",
    style: {
      fill: "#fff",
      stroke: "#45a",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25,
    y: 25,
    width: 70,
    height: 70,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 9.77069V5.73937C18.4 5.34057 18.1739 4.97563 17.8155 4.7958L12.4822 2.11424C12.1792 1.96192 11.8208 1.96192 11.5179 2.11424L6.18457 4.7958C5.82617 4.97669 5.60004 5.34057 5.60004 5.73937V9.77069L1.91471 11.6398C1.55737 11.8207 1.33337 12.1846 1.33337 12.5813V18.925C1.33337 20.0939 2.28804 21.0406 3.46671 21.0406H8.80004V16.8094C8.80004 16.2255 9.27791 15.7516 9.86671 15.7516H14.1334C14.7222 15.7516 15.2 16.2255 15.2 16.8094V21.0406H20.5334C21.712 21.0406 22.6667 20.0939 22.6667 18.925V12.5813C22.6667 12.1846 22.4427 11.8207 22.0854 11.6398L18.4 9.77069ZM10.9334 7.28906H13.0667C13.6555 7.28906 14.1334 7.76296 14.1334 8.34688V10.4625C14.1334 11.0464 13.6555 11.5203 13.0667 11.5203H10.9334C10.3446 11.5203 9.86671 11.0464 9.86671 10.4625V8.34688C9.86671 7.76296 10.3446 7.28906 10.9334 7.28906Z",
    fill: "#933"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructureHighlight);
export default __webpack_public_path__ + "static/media/StructureHighlight.b30cb66687192ae8882f60066a532096.svg";
export { ForwardRef as ReactComponent };